import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private cookieService: CookieService) { }

  public setObject(key: string, obj: any) {
    this.cookieService.set(key, JSON.stringify(obj));
  }

  public getObject(key: string) {
    let obj = this.cookieService.get(key);
    if (obj != null && obj != undefined && obj.length > 0) {
      return JSON.parse(obj);
    }
  }

  public removeAllCookies() {
    this.cookieService.deleteAll();
  }

  public removeCookie(key: any) {
    this.cookieService.delete(key);
  }
}
